module.exports = __webpack_public_path__ + "img/envelope-dot.914a7120.svg";